<template>
  <div>
    <b-row>
      <b-col class="mt-4 mb-2">
        <strong>Oder tragen Sie direkt die Daten ein.</strong>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="9">
        <validation-provider vid="street" rules="required" name="Street" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-street" label="Strasse *" label-for="input-street">
            <b-form-input
              id="input-street"
              v-model="form.strasse"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Strasse angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col class="col">
        <b-form-group id="input-group-street-nr" label="Nr." label-for="input-street-nr">
          <b-form-input
            id="input-street-nr"
            v-model="form.hausNr"
            type="text"
            placeholder="Nr. angeben"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="4">
        <validation-provider vid="zip" rules="required|numeric" name="zip" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-zip" label="PLZ *" label-for="input-zip">
            <b-form-input
              id="input-zip"
              v-model="form.plz"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="PLZ angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col class="col">
        <validation-provider vid="city" rules="required" name="City" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-city" label="Ort *" label-for="input-city">
            <b-form-input
              id="input-city"
              v-model="form.ort"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Ort angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col class="col">
        <validation-provider vid="city" rules="required" name="City" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-city" label="Gemeinde *" label-for="input-city">
            <b-form-select
              v-model="form.gemeindeId"
              :options="communities"
              :state="onValidateField(valid, errors, changed)"
              class="mr-3"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">Gemeinde auswählen</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>

    <b-form-group id="input-group-egid" label="EGID" label-for="input-egid">
      <b-form-input
        id="input-egid"
        v-model="form.egid"
        type="text"
        placeholder="EGID angeben"
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-versicherung" label="Gebäude-Versicherungs-Nr." label-for="input-versicherung">
      <b-form-input
        id="input-versicherung"
        v-model="form.versicherungsNr"
        type="text"
        placeholder="Versicherungs-Nr"
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-parzelle" label="Parzellen-Nr." label-for="input-parzelle">
      <b-form-input
        id="input-parzelle"
        v-model="form.parzellenNr"
        type="text"
        placeholder="Parzellen-Nr."
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-gebauedeart" label="Gebäudeart" label-for="input-gebauedeart">
      <b-form-select  id="input-gebauedeart" v-model="form.gebaeudeart" :options="gebauedearten"></b-form-select>
    </b-form-group>

    <b-form-group id="input-group-nutzungsart" label="Nutzungsart" label-for="input-nutzungsart">
      <b-form-select id="input-nutzungsart" v-model="form.nutzung" :options="nutzungsarten"></b-form-select>
    </b-form-group>

    <b-form-group id="input-group-baujahr" label="Baujahr" label-for="input-baujahr">
      <b-form-input
        id="input-baujahr"
        v-model.number="form.baujahr"
        type="text"
        placeholder="Baujahr"
        v-mask="'####'"
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-anzwohnungen" label="Anzahl Wohnungen" label-for="input-anzwohnungen">
      <b-form-input
        id="input-anzwohnungen"
        v-model.number="form.anzahlWohnungen"
        type="text"
        placeholder="Anzahl Wohnungen"
        v-mask="'###'"
      ></b-form-input>
    </b-form-group>

    <validation-provider vid="denkmalgeschuetzt" rules="required" name="denkmalgeschuetzt" v-slot="{ valid, errors, changed }">
      <b-form-group label="Ist das Gebäude denkmalgeschützt?">
        <b-form-radio-group
          id="input-group-denkmalgeschuetzt"
          label="Denkmalgeschützt"
          label-for="input-denkmalgeschuetzt"
          v-model="form.denkmalgeschuetzt"
          :state="onValidateField(valid, errors, changed)"
        >
          <b-form-radio :value="true">Ja</b-form-radio>
          <b-form-radio :value="false">Nein</b-form-radio>
        </b-form-radio-group>
        <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider vid="energiebezugsflaeche" rules="required" name="energiebezugsflaeche" v-slot="{ valid, errors, changed }">
      <b-form-group
        id="input-group-energiebezugsflaeche"
        label="Energiebezugsfläche *"
        label-for="input-energiebezugsflaeche"
      >
        <b-input-group append="m²">
          <b-form-input
            id="input-energiebezugsflaeche"
            v-model="form.energiebezugsflaeche"
            type="text"
            placeholder="Energiebezugsfläche angeben"
            :state="onValidateField(valid, errors, changed)"
            v-mask="mask"
          ></b-form-input>
          <b-form-invalid-feedback class="invalid-feedback">{{ errors[0] }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </validation-provider>

    <b-form-group
      id="input-group-hauptwaermeerzeugung-bestehend"
      label="Hauptwärmeerzeugung bestehend (Typ)"
      label-for="input-hauptwaermeerzeugung-bestehend"
    >
      <b-form-select
        id="input-hauptwaermeerzeugung-bestehend"
        v-model="form.hauptwaermeerzeugungBestehend"
        :options="hauptwaermeerzeugungen"
      ></b-form-select>
    </b-form-group>

    <b-form-group
      id="input-group-andere"
      label="Welche?"
      label-for="input-andere"
      v-if="form.hauptwaermeerzeugungBestehend === 179"
    >
      <b-form-input
        id="input-andere"
        v-model="form.hauptwaermeerzeugungBestehendAndere"
        type="text"
        placeholder="Falls andere, welche?"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="input-group-hauptwaermeerzeugung-neu"
      label="Hauptheizsystem nach Massnahme"
      label-for="input-hauptwaermeerzeugung-neu"
    >
      <b-form-select
        id="input-hauptwaermeerzeugung-neu"
        v-model="form.hauptwaermeerzeugungNeu"
        :options="hauptwaermeerzeugungen"
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import { ValidationProvider } from 'vee-validate'
  import { validateField, errorHandler } from '@/helpers/formHelper.js'

  export default {
    props: {
      form: Object,
      isSubmitting: Boolean
    },
    components: {
      ValidationProvider
    },
    data: () => ({
      communities: [],
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      mask: createNumberMask({
        prefix: '',
        allowDecimal: false,
        decimalLimit: 2,
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: "'",
        requireDecimal: false
      }),
      gebauedearten: [
        { value: 79, text: 'Neubau' },
        { value: 80, text: 'Bestehend' }
      ],
      nutzungsarten: [
        { value: 28, text: 'Wohnen MFH' },
        { value: 29, text: 'Wohnen EFH' },
        { value: 30, text: 'Verwaltung' },
        { value: 31, text: 'Schulen' },
        { value: 32, text: 'Verkauf' },
        { value: 33, text: 'Restaurants' },
        { value: 34, text: 'Versammlungslokale' },
        { value: 35, text: 'Spitäler' },
        { value: 36, text: 'Industrie' },
        { value: 37, text: 'Lager' },
        { value: 38, text: 'Sportbauten' },
        { value: 39, text: 'Hallenbäder' }
      ],
      hauptwaermeerzeugungen: [
        { value: 173, text: 'Ölheizung' },
        { value: 174, text: 'Gasheizung' },
        { value: 175, text: 'Wärmepumpe' },
        { value: 176, text: 'Elektroheizung' },
        { value: 177, text: 'Holzfeuerung' },
        { value: 178, text: 'Nah-/Fernwärme' }
      ]
    }),
    created () {
      this.getCommunities()
    },
    methods: {
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      getCommunities () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('community/GET_APPLICATION_COMMUNITIES').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const communities = data.gemeinden

          const renamedTypes = communities.map(type => ({
            text: type.name,
            value: type.id
          }))

          this.communities = renamedTypes
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      updateCommunity (value) {
        this.form.gemeindeId = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  .optional{
    text-decoration: underline;
  }
  .invalid-feedback{
    order: 3;
  }
</style>
